import {
    getPipelineTemplate,
    listPipelineTemplates
} from './queries';
import {
    createPipelineTemplate,
    deletePipelineTemplate,
    updatePipelineTemplate,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    CreatePipelineTemplate,
    DeletePipelineTemplate,
    GetPipelineTemplate,
    ListPipelineTemplates,
    PipelineTemplate,
    UpdatePipelineTemplate
} from "../types";
import {pipelinesClient} from "../../pipelines-api-integration/client";


const client = pipelinesClient;

export const fetchRecords = async (query: {
    filter?: object;
    limit?: number;
    nextToken?: string | null;
}) => {
    const {filter, limit, nextToken} = query;
    const response = await client.graphql<GraphQLQuery<ListPipelineTemplates>>({
        query: listPipelineTemplates,
        variables: {filter, limit, nextToken},
    });
    return {
        items: response.data?.listPipelineTemplates.items ?? [],
        nextToken: response.data?.listPipelineTemplates.nextToken,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetPipelineTemplate>>({
                                                                                 query: getPipelineTemplate,
                                                                                 variables: {id: id},
                                                                             });
    return response.data?.getPipelineTemplate;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreatePipelineTemplate>>({
                                                                                    query: createPipelineTemplate,
                                                                                    variables: {input: payload},
                                                                                });
    return response.data?.createPipelineTemplate;
};

export const update = async (_id: string, record: PipelineTemplate) => {

    delete record.created;
    delete record.updated;
    delete record.createdByUsername;
    delete record.managedByUsername;

    const response = await client.graphql<GraphQLQuery<UpdatePipelineTemplate>>({
                                                                                    query: (updatePipelineTemplate),
                                                                                    variables: {input: record},
                                                                                });
    return response.data?.updatePipelineTemplate;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeletePipelineTemplate>>({
                                                                                    query: (deletePipelineTemplate),
                                                                                    variables: {input: {id: id}},
                                                                                });
    return response.data?.deletePipelineTemplate;
};
